import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { authReducer } from './reducers/login.reducer';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { vendorReducer } from './reducers/vendor.reducer';
import { adminReducer } from './reducers/admin.reducer';
import { supervisorReducer } from './reducers/supervisor.reducer';
import { providerReducer } from './reducers/provider.reducer';
import practitionersReducer from './reducers/practitioners.reducer';
import ghlStaffCalendarsReducer from './reducers/ghlStaffPractitioners.reducer';
import clinicPractitionerReducer from './reducers/ClinicPractitioners.reducer';
import patientDataReducer from './reducers/patientData.reducer';

const rootPersistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'patientData'],
};

const rootReducer = combineReducers({
  user: authReducer,
  vendor: vendorReducer,
  admin: adminReducer,
  supervisor: supervisorReducer,
  provider: providerReducer,
  practitioners: practitionersReducer,
  ghlStaffPractitioners: ghlStaffCalendarsReducer,
  clinicPractitioner: clinicPractitionerReducer,
  patientData: patientDataReducer,
});

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export default store;

export const persistor = persistStore(store);
